import axios from "@/util/axios";

const PREFIX_URI = "/order/stock/stocktaking";

export default {
    /** 分页查询盘点单列表 */
    queryList: (data) => axios.get({url: `${PREFIX_URI}/queryList`, data}),
    /** 查询盘点单详情（含明细） */
    findById: (id) => axios.get({url: `${PREFIX_URI}/findById`, data: {id}}),
    /** 保存盘点单（草稿） */
    save: (data) => axios.post({url: `${PREFIX_URI}/save`, data}),
    /** 提交盘点单（自动生成报损/报溢单据并调整库存） */
    submit: (id) => axios.post({url: `${PREFIX_URI}/submit?id=${id}`}),
    /** 删除盘点单 */
    delete: (id) => axios.del({url: `${PREFIX_URI}/delete`, data: {id}}),
    /** 按商品查询当前仓库的库存批次信息（盘点添加商品时用） */
    queryStockBatchVoByProducts: (warehouseId, productIds) => axios.post({url: `${PREFIX_URI}/queryStockBatchVoByProducts?warehouseId=${warehouseId}`, data: productIds}),
}
